import { AfterViewInit, Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@/app.service';
import { TranslateService } from '@ngx-translate/core';
import { IpService } from '@/ip-service.service';
import {
  ApiListResponse,
  ApiObjectResponse,
  ApiResponse,
  PaginationData,
} from '@/shared/models/api-response.interface';
import { PublicationService } from '../citizen-publications/services/publication.service';
import { Publication } from '../citizen-publications/models/publication.model';
import { Geometre } from './models/geometre.interface';
import { ToastrAlertComponent } from '@/shared/components/toastr-alert/toastr-alert.component';
import { Parcelle } from './models/parcelle.interface';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';

declare let $: any;
declare var window: any;
@Component({
  selector: 'app-citizen-home',
  templateUrl: './citizen-home.component.html',
  styleUrl: './citizen-home.component.css',
})
export class CitizenHomeComponent implements OnInit, AfterViewInit {
  @ViewChild('toastrAlert') toastrAlert!: ToastrAlertComponent;

  Model = { code: 'string' };
  code: string = '';
  ip: any;

  numero!: string;
  parcelle: Parcelle | undefined;

  formExampleModalInitialisationDetails: any;
  searc_loader = false;
  geometres: Geometre[] = [];
  paginationData: PaginationData | undefined;

  searchTerm: string = '';
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  currentPage: number = 0;
  pageSize: number = 10;
  lastestPublicationsData!: ApiListResponse<Publication>;
  publicationState: {
    loading: boolean;
    error: string | null;
  } = {
    loading: false,
    error: null,
  };

  constructor(
    private _route: Router,
    private _api: AppService,
    private _ipService: IpService,
    private renderer: Renderer2,
    private _router: ActivatedRoute,
    private _publicationService: PublicationService,
    private translate: TranslateService
  ) {
    this.translate.addLangs(['en', 'fr']);
    this.translate.setDefaultLang('fr');

    this._router.params.subscribe((params) => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang.match(/en|fr/) ? lang : 'en');
      }
    });
  }

  ngOnInit(): void {
    this._router.queryParams.subscribe((params) => {
      this.code = params['code'];

      if (this.code) {
        this.generateTokenWithCode();
      }
    });

    this.formExampleModalInitialisationDetails = new window.bootstrap.Modal(
      document.getElementById('exampleModalInitialisationDetails')
    );

    this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((term) => {
        this.searchTerm = term.trim();
        this.performSearch(term);
      });

    this.getAllGeo();
    this.getLatestPublications();
  }

  generateTokenWithCode() {
    // console.log('generateTokenWithCode called with ip:', ip, 'and code:', this.code);
    this.Model.code = this.code;
    this._api.getCallBackCode(this.Model, '255.255.255.255').subscribe((res: any) => {
      if (res.status === 200) {
        localStorage.setItem('globalData', JSON.stringify(res.objects));
        localStorage.setItem('Authorized', 'TRUE');

        // Générer un token local avec validité 24h
        const localToken = this.generateLocalToken(res.objects);
        localStorage.setItem('token', localToken);

        // console.log("YESSSS")

        this._route.navigate(['/portail-citoyen/citizens-liste-parcel']);
        // console.log("GOOOD")
        this.updateData(res.objects);
      }
    });
  }

  getLatestPublications() {
    this.publicationState.loading = true;
    this._publicationService.getPublications(0, 6).subscribe({
      next: (data) => {
        this.lastestPublicationsData = data;
        this.publicationState.loading = false;
      },
      error: (err) => {
        this.publicationState.loading = false;
        this.publicationState.error =
          'Une erreur est survenue lors du chargement des publications.';
      },
    });
  }

  getAllGeo(page: number = 0) {
    if (this.searchTerm.trim()) {
      this._ipService.searchGeo(this.searchTerm, page, this.pageSize).subscribe({
        next: (data: ApiObjectResponse<ApiListResponse<Geometre>>) => {
          this.processPaginatedResponse(data);
        },
        error: (err: any) => {
          this.handleError(err);
        },
      });
    } else {
      this._ipService.getAllGeo(page, this.pageSize).subscribe({
        next: (data: ApiObjectResponse<ApiListResponse<Geometre>>) => {
          this.processPaginatedResponse(data);
        },
        error: (err: any) => {
          this.handleError(err);
        },
      });
    }
  }

  processPaginatedResponse(data: ApiObjectResponse<ApiListResponse<Geometre>>) {
    if (data?.objects) {
      const { content, ...paginationData } = data.objects;
      this.geometres = content || [];
      this.paginationData = paginationData;
    } else {
      this.geometres = [];
    }
  }

  handleError(err: any) {
    console.error('Erreur lors de la récupération de la liste des géomètres', err);
    this.geometres = [];
  }

  clearSearch() {
    this.searchTerm = '';
    this.currentPage = 0;
    this.getAllGeo(0);
  }

  onSearchInput(term: string): void {
    this.searchSubject.next(term);
  }

  performSearch(term: string): void {
    this.currentPage = 0;
    this.getAllGeo(0);
  }

  reloadGeometres(data: { page: number; perPage: number }) {
    this.currentPage = data.page;
    this.pageSize = data.perPage;
    console.log(this.pageSize);
    this.getAllGeo(this.currentPage);
  }

  trackByGeoId(index: number, geo: any): any {
    return geo.id || index;
  }

  // getmyPublicIp() {
  //   this._ipService.getIpAddress().subscribe({
  //     next: (data) => {
  //       this.ip = data.ip;
  //       this.generateTokenWithCode(this.ip);
  //     },
  //     error: (err) => {
  //       console.error('Erreur lors de la récupération de l’adresse IP:', err);
  //     },
  //   });
  // }

  generateLocalToken(userData: any): string {
    const tokenData = {
      ...userData,
      timestamp: Date.now(),
      expiresAt: Date.now() + 24 * 60 * 60 * 1000, // 24 heures
    };

    return btoa(JSON.stringify(tokenData)); // Encode en base64
  }

  displayParcellInformation() {
    this.searc_loader = true;
    this._api.requestForParcelInformations(this.numero).subscribe({
      next: (res: ApiResponse<Parcelle>) => {
        if (res.status === false) {
          this.searc_loader = false;
          this.toastrAlert.showErrorToast(
            res.message === 'ParcelNotExists' ? "Cette parcelle n'existe pas" : res.message
          );
          return;
        }

        this.parcelle = res.data;
        this.parcelle.registerType =
          this.parcelle.registerType === 'privateParcel' ? 'Parcelle privée' : 'Parcelle publique';

        this.searc_loader = false;

        this.formExampleModalInitialisationDetails.show();
      },
      error: (error: any) => {
        this.searc_loader = false;
        this.toastrAlert.showErrorToast("Une erreur s'est produite, veuillez réessayer plus tard.");
      },
    });
  }
  // accederAuxDemandes() {
  //   if (this.token()) {
  //     // // console.log('Connecté Connecté Connecté ')
  //     // this._route.navigate(['/portail-citoyen/citizens-liste-parcel'])
  //     this._route.navigate([
  //       '/portail-citoyen/citizens-liste-eservices',
  //       'individualRegistration',
  //       'enregistrement-individuel',
  //       1,
  //     ]);
  //   } else {
  //     window.open(environment.URL_LINK, '_blank');
  //   }
  // }

  updateData(data: any) {
    // Mettre à jour les données globales
    // const newData = { username: 'JohnDoe', age: 25 };
    this._api.updateGlobalData(data);
  }

  ngAfterViewInit(): void {
    // AOS.init();
    $('#slide_patenaire').slick({
      speed: 5000,
      autoplaySpeed: 0,
      autoplay: true,
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      useTransform: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
      prevArrow: false,
      nextArrow: false,
    });
  }
}
